import { Form } from "react-bootstrap"
import Select from "react-select"
import { ISelectFieldOption } from "../../state/formTypes"
import Label from "./Label"

export type TSelectFieldOptions = ISelectFieldOption[];

interface IProps {
  title: string;
  formikProps: any;
  placeholderText?: string;
  options: TSelectFieldOptions;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: any) => void; // Add an optional onChange prop
}

const FormikSelect = (props: IProps): JSX.Element => {
  const handleChange = (selectedOption: any) => {
    // Update Formik value
    props.formikProps.setFieldValue(props.title, selectedOption?.value);

    // Call the external onChange function if provided
    if (props.onChange) {
      props.onChange(selectedOption?.value);
    }
  };

  // validation may fail fix line number 28
  return (
    <>
      <Form.Group controlId="exampleForm.ControlInput1">
        <Label title={props.title} required={props.required} />
        <Select
          name={props.title}
          id={props.title}
          placeholder={
            props.placeholderText ? props.placeholderText : "Select . . ."
          }
          onChange={handleChange} // Use the handleChange function here
          onBlur={(): any => {
            props.formikProps.handleBlur({
              target: { name: `${props.title}` }
            })
          }}
          value={props.options.filter((option: any) => {
            return option.value === props.formikProps.values[props.title]
          })}
          isSearchable={true}
          options={props.options}
          className={
            props.formikProps.touched[props.title] &&
            props.formikProps.errors[props.title]
              ? "error"
              : ""
          }
          isDisabled={props.disabled ? props.disabled : false}
        />
        {props.formikProps.touched[props.title] &&
        props.formikProps.errors[props.title] ? (
            <div className="error-message">
              {props.formikProps.errors[props.title]}
            </div>
          ) : null}
      </Form.Group>
    </>
  )
}

export default FormikSelect
